import { render } from "./UltraPage.vue?vue&type=template&id=0a4cb967&scoped=true"
import script from "./UltraPage.vue?vue&type=script&lang=js"
export * from "./UltraPage.vue?vue&type=script&lang=js"

import "./UltraPage.vue?vue&type=style&index=0&id=0a4cb967&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4cb967"]])

export default __exports__